import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onUnmounted, onMounted, PropType, ref } from 'vue'
import { __ } from '@/locales'
import { getUUID } from '@/common/Utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'BasePopup',
  props: {
  opened: { type: Boolean as PropType<boolean> },
  required: { type: Boolean as PropType<boolean>, default: true },
},
  emits: ["close", "validate"],
  setup(__props, { emit: emits }: { emit: ({
  (event: 'close'): void
  (event: 'validate'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const id = ref('popup' + getUUID())





onMounted(() => {
  const app = document.querySelector('#app')
  const popup = document.querySelector(`#${id.value}`)
  if (!popup) return
  app?.prepend(popup)
})

onUnmounted(() => {
  const popup = document.querySelector(`#${id.value}`)
  popup?.remove()
})

const close = () => {
  emits('close')
}

return (_ctx: any,_cache: any) => {
  const _component_dig_ui_popup = _resolveComponent("dig-ui-popup")!

  return (_openBlock(), _createBlock(_component_dig_ui_popup, {
    id: id.value,
    toggled: __props.opened,
    required: __props.required,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (close()))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["id", "toggled", "required"]))
}
}

})